<template>
  <div class="wrapper" ref="wrapper">
    <!-- 头图 -->
    <header>
      <img :src="ui.head" alt="头图" class="header_img">
    </header>
    <div :style="`backgroundColor:${ui.bg_color}`" ref="main" class="main_wrapper">
      <!-- 倒计时 -->
      <countDown v-if="ui.is_counter" :labelColor="ui.font_color"
                 :stime="stime"></countDown>
      <div class="form_wrapper" ref="form_wrapper">
        <!-- 表单部分 -->
        <van-form ref="actionForm">
          <p class="vant_label" :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#000'}"
             v-if="is_city">快速选择城市</p>
          <van-field
              v-if="is_city"
              v-model="action_form.city"
              is-link
              readonly
              placeholder="请选择城市"
              @click="city_show = true"
          />
          <p class="vant_label" :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#000'}">怎么称呼您</p>
          <van-field
              v-model="action_form.name"
              name="姓名"
              placeholder="请输入姓名"
          />
          <p class="vant_label" :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#000'}">您的手机号(已加密)</p>
          <van-field
              type="tel"
              v-model="action_form.phone"
              name="电话"
              placeholder="请输入电话"
          />

          <div class="policy_wrapper">
            <policy></policy>
          </div>
          <div>
            <div
                class="form_item_btn able_btn"
                round v-if="!is_stop" @click="submitBaseForm"
                :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
              {{ui.btn_text}}
            </div>
            <van-button class="form_item_btn"
                        type="info" round v-if="is_stop" :disabled="true">活动已结束
            </van-button>
          </div>
        </van-form>
      </div>
      <!-- 走马灯-->
      <banner v-if="ui.is_banner"></banner>
    </div>
    <div class="detail_img" :class="ui.is_copyright ? '' : 'pb_20'">
      <!-- 详情图-->
      <img :src="ui.tail" alt="详情图" class="detail_img" ref="tailImage"/>
    </div>
    <!-- 版权-->
    <div style="padding-bottom: 40px">
      <copyright v-if="ui.is_copyright"></copyright>
    </div>
    <!--        :style="{display: is_display ? 'none' : 'block'}"-->
    <div v-if="btn_show" class="footer_wrapper">
      <div class="bottom_btn"
           @click="btn_click_form"
           :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
        {{ui.btn_text}}
      </div>
    </div>

    <!--车型弹框 vant-->
    <van-popup v-if="!custom_car" v-model="is_dialog_car"
               position="right" :style="{height: '100%',width: '80%'}">
      <carlist_img
          :activity_id="Number(activity_id)" :custom_car="Number(custom_car)"
          @query="query_car"></carlist_img>
    </van-popup>

    <van-popup v-if="custom_car" v-model="is_dialog_car" round
               position="bottom" :style="{height: '80%',width: '100%'}">
      <carlist_noimg
          :activity_id="Number(activity_id)" :custom_car="Number(custom_car)" :is_dialog_car="is_dialog_car"
          @query="query_car" @handleClose="handleClose"></carlist_noimg>
    </van-popup>

    <!-- 报名成功弹框-->
    <el-dialog :visible.sync="is_success" v-if="is_success" class="Successful" width="50%">
      <el-result icon="success" title="报名成功"></el-result>
    </el-dialog>

    <!--  城市弹框-->
    <!-- :style="{height: '50%'}" :lock-scroll="false"-->
    <van-popup v-model="city_show" round position="bottom" :safe-area-inset-bottom="true">
      <!-- style="height: 100%;overflow-x: hidden;overflow-y: auto" -->
      <van-cascader
          v-model="cascaderValue"
          title="请选择所在地区"
          :options="citys"
          :fieldNames="cityNames"
          @close="city_show = false"
          @finish="finishCity"
          class="city_cascader"
      >
      </van-cascader>
    </van-popup>

    <van-popup v-model="sub_car_dialog" round   :safe-area-inset-bottom="true">
        <div class="sub_dialog">
          <h2 style="color: #333333;text-align: center;margin-bottom: 10px">
            请补充信息
          </h2>
          <p class="vant_label" style="color: #333;">您的意向车型</p>
          <van-field
              v-model="action_form.car_name"
              is-link
              readonly
              placeholder="请选择意向车型"
              @click="is_dialog_car = true"
          />
          <div
              class="form_item_btn able_btn"
              round v-if="!is_stop" @click="submitForm"
              :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`"
              style="margin-top: 30px">
            {{ui.btn_text}}
          </div>
          <van-button class="form_item_btn" style="margin-top: 30px"
                      type="info" round v-if="is_stop" :disabled="true">活动已结束
          </van-button>

        </div>

    </van-popup>
  </div>
</template>

<script>
  import countDown from "@/components/countDown";
  import policy from "@/components/policy";
  import copyright from "@/components/copyright";
  import banner from "@/components/banner";
  import carlist_img from "@/components/carlist_img";
  import carlist_noimg from "@/components/carlist_noimg";
  import _geturl from "@/utils/_geturl";
  import lib_activity from "@/libs/lib_activity";
  import lib_city from "@/libs/lib_city";
  import _wx from "@/common/_wx";
  import _time from "@/utils/_time";
  import _object from "@/utils/_object";
  import _regular from "@/utils/_regular";
  import lib_clue from "@/libs/lib_clue";
  import lib_success from "@/libs/lib_success";
  import cache_url from "@/cache/cache_url";
  import Toast from "vant/lib/toast";
  import _monitor from "@/monitor/_monitor";

  let action_form = {
    brand_name: '', //品牌名称
    series_name: '', // 车型名称
    brand_id: 0,  // 品牌id
    series_id: 0, // 车型id
    automaker_id: 0,
    car_name: '', //品牌/车型名称
    name: '', // 姓名
    phone: '', //电话
    city: '', //城市
  }

  export default {
    name: "common",
    components: {
      carlist_noimg,
      carlist_img,
      countDown,
      policy,
      copyright,
      banner,
    },
    data() {
      return {
        title: '', // document的title
        activity_id: 0, //活动ID
        custom_car: 0, // 是否自定义车型库
        tids: "", //模板ID
        channel: '', //渠道
        channel_name: '', //渠道名
        tid: 0, // 有无车型库
        share_theme: '', //分享描述
        stime: 0, // 项目开始时间
        etime: 0, // 项目结束时间
        ui: {
          head: '', //头图
          tail: '', //详情图
          share: '', //分享图
          bg_color: '', //表单背景色
          font_color: '', //文本颜色
          btn_bg_color: '', //按钮背景色
          btn_font_color: '', //按钮文本颜色
          btn_text: '', //按钮文本值
          btm_btn_text: '', //底部按钮文本
          is_banner: 0, //是否有轮播图
          is_counter: 0, //是否有倒计时
          is_copyright: 1, //协议
          jmp_url: 0, //0-报名成功;1-帮朋友报名;2-置换二手车;3-邮寄门票
        },

        action_form: action_form,
        //城市联级选择
        citys: [], //城市数据
        cascaderProps: { //配置项
          expandTrigger: 'hover', //展开方式
          value: "id", //指定选项的值
          label: "name", //指定选项标签
          children: "children", //指定选项的子选项
          emitPath: false, //该节点数组
        },


        is_dialog_car: false, //车型弹框
        is_success: false, //报名成功弹框
        is_city: false, //表单城市项，默认无城市
        is_stop: false, //活动是否已结束
        is_display: true, //底部按钮
        btn_show: false, //底部按钮显隐
        series_name: "请选择意向车型",

        // show: false,
        city_show: false,
        cascaderValue: '', //
        cityNames: {
          text: 'name',
          value: 'id',
          children: 'children',
        },

        sub_car_dialog: false,
      }
    },
    created() {
      // 地址栏
      this.activity_id = _geturl("activity_id");
      this.tids = _geturl("tids");
      this.channel = _geturl("channel");
      this.channel_name = _geturl("channel_name");

      //获取项目信息
      lib_activity.info(this.activity_id, this.tids, this.init_info);

      //监测
      _monitor.init(this.channel, this.activity_id);
      console.log(window.location.href, '===')
    },
    mounted() {
      // 监听页面滚动
      window.addEventListener('scroll', this.handleScroll, true)
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll, true)
    },
    destroyed() {
      // window.removeEventListener('scroll', this.handleScroll())
    },
    methods: {
      //初始化项目信息
      init_info(data) {
        console.log(data)
        this.title = data.activity.theme;
        document.title = this.title;
        this.share_theme = data.activity.share_theme;
        this.etime = data.activity.etime;
        this.stime = data.activity.stime;
        this.tid = data.activity.tid;
        this.custom_car = data.activity.custom_car;
        if(data.ui == null) {
          this.ui = {};
          return;
        }
        this.ui = data.ui;

        // 项目结束
        if (!data.activity.state || (_time._current() > data.activity.etime)) {
          this.is_stop = true;
          return;
        }

        // 判断是否有城市
        let city = []
        if (data.activity.city) {
          city = data.activity.city.split(',');
        }
        if (city.length == 1 && city[0] > 0) {
          //单城市项目
          this.is_city = false;
        } else {
          //多城市项目
          this.is_city = true;
          this.getCity(data.activity.city)
        }

        // 分享： ui存在再分享
        if (_object._length(this.ui) > 0) {
          this.share();
        }
      },

      // 分享
      share() {
        let that = this;
        lib_activity.share(function (data) {
          let options = {};
          options.title = that.title;
          options.desc = that.share_theme;
          options.link = window.location.href;
          options.image = that.ui.share;

          _wx.js_api(data, _wx.share, options);
        })
      },

      // 加载城市
      getCity(city) {
        let that = this;
        lib_city.list(city, function (data) {
          that.citys = data;
        })
      },
      // 选择车
      clk_brand() {
        this.is_dialog_car = true;
      },

      query_car(brand_id, brand_name, series_id, series_name) {
        this.action_form.brand_id = brand_id;
        this.action_form.brand_name = brand_name;
        this.action_form.series_id = series_id;
        this.action_form.series_name = series_name;
        this.action_form.car_name = brand_name + '/' + series_name;
        this.is_dialog_car = false;
      },


      submitBaseForm() {
        if (this.is_city && !this.action_form.city) {
          Toast('请选择城市');
          return;
        }
        if (!this.action_form.name) {
          Toast('请输入您的姓名');
          return;
        }
        if(this.action_form.name && this.action_form.name.length>20) {
          Toast('请输入正确的姓名');
          return;
        }
        if (!this.action_form.phone) {
          Toast('请输入您的手机号');
          return;
        }
        if (!_regular.is_mobile(this.action_form.phone)) {
          Toast('请输入正确的手机号');
          return;
        }

        //车型二级弹框
        this.sub_car_dialog = true
      },

      submitForm() {
        console.log(this.action_form, '表单')

        if (!this.action_form.series_id) {
          Toast('请选择品牌车型');
          return;
        }
        //
        // let city_node = this.$refs.bind_city_ref.getCheckedNodes()[0]
        // let province = city_node.parent.label;
        // let city = city_node.label;
        let cityArr = this.action_form.city.split('/'); // vant形式
        let location = this.is_city ? (cityArr[0] + '+' + cityArr[1]) : '';
        let url = window.location.href;
        let form_ui_id = this.ui.hasOwnProperty("id") ? this.ui.id : 0;
        let params = {
          activity_id: this.activity_id,
          channel_code: this.channel,
          channel_name: this.channel_name,
          url,
          location,
          form_name: this.action_form.name,
          form_phone: this.action_form.phone,
          form_brand: this.action_form.brand_name,
          form_series: this.action_form.series_name,
          form_ui_id,
        };
        let that = this;
        lib_clue.receive(params, function (data) {
          //监测上报
          _monitor.submit()

          //缓存当页面链接
          cache_url.set(window.location.href)
          //跳转
          // setTimeout(() => {
          // }, 10);
          //不同参数跳转不同页面
          const jmp_url = _object._length(that.ui) > 0 ? that.ui.jmp_url : 0

          that.sub_car_dialog = false
          //跳转地址
          const url = lib_success.jmp_url(jmp_url)
          that.$router.push({
            path: url,
            query: {
              id: data.id
            },
          })
        })
      },

      // 滚到表单开始部分
      btn_click_form() {
        let form_top = this.$refs.main.offsetTop - 50;
        document.documentElement.scrollTop = form_top
        document.body.scrollTop = form_top
        document.querySelector('#app').scrollTop = form_top
      },
      // 滚动
      handleScroll() {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || document.querySelector('#app').scrollTop;
        // console.log(document.querySelector('#app').scrollTop)
        this.$nextTick(() => {
          if (scrollHeight >= this.$refs.tailImage.offsetTop) {
            this.is_display = false;
            this.btn_show = true;
          } else {
            this.is_display = true;
            this.btn_show = false;
          }
        })
      },
      finishCity({selectedOptions}) {
        this.city_show = false;
        this.action_form.city = selectedOptions.map((option) => option.name).join('/');
      },

      handleClose(flag) {
        this.is_dialog_car = flag;
      },
    },
    watch: {
      is_dialog_car(val) {
        let scrollWidth = document.innerWidth - document.documentElement.offsetWidth;
        if (val) {
          document.body.style.overflow = 'hidden';
          document.body.style.paddingRight = scrollWidth + 'px'
        } else {
          document.body.style.overflow = 'scroll';
          document.body.style.paddingRight = scrollWidth + 'px'
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  @import "../../assets/style/autoshow/base.less";
  @import "../../assets/style/autoshow/form.less";
  // form
  @import "../../assets/style/common/successful.less"; //报名成功
  @import "../../assets/style/autoshow/base_form.less";
  .city_cascader {
    /deep/ .van-tabs .van-tabs--line .van-cascader__tabs {
      overflow-y: auto;
    }
  }

  .sub_dialog{
    width: 90vw;
    padding: 20px;
    box-sizing: border-box;
    h2{
      font-size: 32px;
    }
  }
</style>

